var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"four-zero-four"},[_c('div',{staticClass:"four-zero-four-container"},[_c('div',{staticClass:"error-code"},[_vm._v("404")]),_c('div',{staticClass:"error-message"},[_vm._v("Không tìm thấy trang theo yêu cầu")])])])
}]

export { render, staticRenderFns }